import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4.46}
      d="m14.457 3.055 9.75 7.14-9.47 6.75M23.802 10.166H2.295"
    />
  </svg>
)
export default SvgComponent
